import { Injectable } from '@angular/core';
import { hubConst } from '@app/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root',
})
export class OpenaiService {
    private readonly _baseUrl = `${hubConst.api.assessments}/v1/`;

    constructor(private api: ApiService) { }

    public magicText(data: any): Observable<any> {
        return this.api.post(`${this._baseUrl}ia/magic-text`, data);
    }

    public magicImage(data: any): Observable<any> {
        return this.api.post(`${this._baseUrl}ia/magic-image`, data);
    }
}
